require("./components/min");

require("../html-components/linkify");

window.Vue = require("vue");

Vue.component("tz-time", require("../components/TzTime.vue").default);

Vue.component(
  "starts-in-badge",
  require("../components/StartsInBadge.vue").default
);

Vue.use(require("vuera").VuePlugin);

Vue.component(
  "follow-button",
  require("../react/FollowButton/FollowButton.vue").default
);

new Vue({ el: "#app" });
